import React from 'react';

import { BaseModal } from '../../../../components/BaseModal';

interface ConfirmRemoveBuyerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userName: string;
  buyerName: string;
}

export const ConfirmRemoveBuyerModal: React.FC<
  ConfirmRemoveBuyerModalProps
> = ({ isOpen, onClose, onConfirm, userName, buyerName }) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title="Remove User from Buyer"
      footerContent={{
        onCancel: onClose,
        onConfirm: handleConfirm,
        confirmText: 'Remove',
        isDestructive: true,
      }}
    >
      <div className="space-y-4">
        <p className="text-default-600">
          Are you sure you want to remove{' '}
          <span className="font-semibold text-default-900">
            {userName || 'the current user'}
          </span>{' '}
          from{' '}
          <span className="font-semibold text-default-900">{buyerName}</span>?
        </p>
        <p className="text-small text-default-500">
          By removing this user, they will be removed from all chats associated
          with this buyer entity.
        </p>
      </div>
    </BaseModal>
  );
};
